<page-heading
  [title]="'notification.home.title' | translate"
  [description]="'notification.home.description' | translate"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-xs-12 col-md-12 input-trend-search">
            <input 
              type="search" 
              #searchBox 
              class="form-control"
              [placeholder]="'notification.home.searchPlaceholder' | translate"
              (keyup)="search(searchBox.value)" 
            />
            <span class="mdi mdi-magnify search-icon ml-2"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card">
  @if(loadingContent) {
    <content-loading-list></content-loading-list>
  }

  @if (!loadingContent && pager.total == 0) {
    <empty-records-legacy-component 
      [message]="'notification.home.emptyRecords' | translate">
    </empty-records-legacy-component>
  }

  @if (pager.total > 0) {
    <div class="card-body table-responsive">
      <table class="table table-hover table-centered mb-0">
        <thead>
          <tr>
            <th class="text-primary-emphasis">{{ 'notification.home.columnTitle' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'notification.home.columnDescription' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'notification.home.columnType' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'notification.home.columnDate' | translate }}</th>
            <th><span class="sr-only"></span></th>
          </tr>
        </thead>
        <tbody>
          @for (item of pager.list; track $index) {
            <tr>
              <td>{{item.title}}</td>
              <td><span title="{{removeHtml(item.description)}}">{{removeHtml(item.description) | truncate: 55}}</span> </td>

              <td>
                @if (item.type === 'IMPORTATION') {
                  <span>
                    <span class="badge font-14 bg-primary text-white">{{ 'notification.home.typeImportation' | translate }}</span>
                  </span>
                }
                @if (item.type === 'ATTENDANCE') {
                  <span>
                    <span class="badge bg-primary text-white">{{ 'notification.home.typeAttendance' | translate }}</span>
                  </span>
                }
                @if (item.type === 'COMPANY') {
                  <span>
                    <span class="badge font-14 bg-primary text-white">{{ 'notification.home.typeCompany' | translate }}</span>
                  </span>
                }
                @if (item.type === 'MESSAGE') {
                  <span>
                    <span class="badge font-14 bg-primary text-white">{{ 'notification.home.typeMessage' | translate }}</span>
                  </span>
                }
                @if (item.type === 'USER') {
                  <span>
                    <span class="badge font-14 bg-primary text-white">{{ 'notification.home.typeUser' | translate }}</span>
                  </span>
                }
                @if (item.type === 'WARNING_WORD') {
                  <span>
                    <span class="badge font-14 bg-primary text-white">{{ 'notification.home.typeWarningWord' | translate }}</span>
                  </span>
                }
                @if (item.type === 'CSAT') {
                  <span>
                    <span class="badge font-14 bg-primary text-white">{{ 'notification.home.typeCsat' | translate }}</span>
                  </span>
                }
                @if (item.type === 'USER_ADDED') {
                  <span>
                    <span class="badge font-14 bg-primary text-white">{{ 'notification.home.typeUserAdded' | translate }}</span>
                  </span>
                }
                @if (item.type === 'CREDIT') {
                  <span>
                    <span class="badge font-14 bg-primary text-white">{{ 'notification.home.typeCredit' | translate }}</span>
                  </span>
                }
              </td>
              <td>{{$safeNavigationMigration(item?.createdAt) | timezoneDate: 'DD/MM/YYYY HH:mm:ss': getTimezoneCompanyCurrentUser()}}</td>
              <td>
                <div class="d-flex justify-content-end">
                  <button 
                    type="button"
                    class="btn btn-dropdown-list" 
                    [matMenuTriggerFor]="menu" 
                  >
                    <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                  </button>

                  <mat-menu #menu="matMenu">
                    <button mat-menu-item tabindex="0" (click)="notify(item)">{{ 'notification.home.actionView' | translate }}</button>
                    <button mat-menu-item tabindex="0" (click)="delete(item)">{{ 'notification.home.actionDelete' | translate }}</button>
                  </mat-menu>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
      @if (pager.total > pager.perPage) {
        <paginator 
          [pager]="pager"
          (onPager)="loadPage($event)"
        />
      }
    </div>
  }
</div>
